module.exports = __webpack_public_path__ + "static/media/presentation_1.d3a5c74a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/presentation_1.svg
// module id = 630
// module chunks = 1